var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFewClouds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weather-cloud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,3a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2A1,1,0,0,0,9.25,3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.416,4.83A1,1,0,1,0,4.83,3.416l-.707-.707A1,1,0,0,0,2.709,4.123Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3,9.25a1,1,0,0,0-1-1H1a1,1,0,0,0,0,2H2A1,1,0,0,0,3,9.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.377,5.123a1,1,0,0,0,.707-.293l.707-.707a1,1,0,0,0-1.414-1.414l-.707.707a1,1,0,0,0,.707,1.707Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.916,11.994a.249.249,0,0,0,.109-.38,4,4,0,0,1,6.343-4.867.253.253,0,0,0,.264.084A8.548,8.548,0,0,1,14.2,6.537a.25.25,0,0,0,.191-.378A6,6,0,1,0,4.279,12.606a.25.25,0,0,0,.346.068A6.939,6.939,0,0,1,5.916,11.994Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.094,15.074a.252.252,0,0,1-.1-.193A7,7,0,0,0,8.338,12.84a.249.249,0,0,1-.22.173A5.5,5.5,0,0,0,8.5,24H19a5,5,0,0,0,3.094-8.926ZM22,19a3,3,0,0,1-3,3H8.5a3.5,3.5,0,1,1,.448-6.971.994.994,0,0,0,1.116-.833A5,5,0,0,1,20,15c0,.146-.007.289-.02.433a1,1,0,0,0,.5.959A3.007,3.007,0,0,1,22,19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewClouds);
export default __webpack_public_path__ + "static/media/few_clouds.33363776d51bcc3a06c3b4e821640b6a.svg";
export { ForwardRef as ReactComponent };